<template>
  <div class="container-fluid mb-6 mb-md-0">
    <router-view />
  </div>
</template>

<script>
import FiflFooter from '../../components/FiflFooter';
import { computedGetters } from '@/utils/vuex-helper';

export default {
  name: 'Notice',
  components: { FiflFooter },
  computed: {
    ...computedGetters(['isNoticeMenuVisible']),
    isLightGreyPlan() {
      return this.$store.getters.getIsLightGreyPlan;
    }
  },
  watch: {
    isNoticeMenuVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    },
    isLightGreyPlan: {
      immediate: true,
      handler: function(isAccessBlocked) {
        if (isAccessBlocked) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
